module.exports = __webpack_public_path__ + "h5/img/summer-navc44.7e1c47ee.png";